import React from 'react';

const FormSelect = ({ label, value, onChange, options, required, helperText, error }) => {
  return (
    <div>
      <label className="block text-sm font-semibold text-gray-700 mb-1">
        {label} {required && <span className="text-red-500">*</span>}
      </label>
      <select
        value={value || ''}
        onChange={(e) => onChange(e.target.value)}
        required={required}
        className={`w-full px-3 py-2 border rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent bg-white ${
          error ? 'border-red-400 bg-red-50' : 'border-gray-300'
        }`}
      >
        <option value="">Select...</option>
        {options.map((option) => {
          const isObj = typeof option === 'object' && option !== null;
          const val = isObj ? option.value : option;
          const lbl = isObj ? option.label : option;
          return (
            <option key={val} value={val}>
              {lbl}
            </option>
          );
        })}
      </select>
      {error && (
        <p className="text-xs text-red-600 mt-1">{error}</p>
      )}
      {helperText && !error && (
        <p className="text-xs text-gray-500 mt-1">{helperText}</p>
      )}
    </div>
  );
};

export default FormSelect;
